<template>
  <div class="addCompetitionManagement">
    <div class="topTitle">
      <span style="cursor: pointer;" @click="goback">返回</span> / 新增比赛
    </div>
    <div class="table">
      <el-form label-position="top">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="比赛名称" required>
              <el-input
                v-model="contest.title"
                placeholder="请输入比赛名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="描述" required>
              <Tinymce v-model="contest.description"></Tinymce>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开始时间" required>
              <el-date-picker
                v-model="contest.start_time"
                type="datetime"
                placeholder="请选择时间"
                placement="bottom-start"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束时间" required>
              <el-date-picker
                v-model="contest.end_time"
                type="datetime"
                placeholder="请选择时间"
                placement="bottom-start"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="比赛密码">
              <el-input
                v-model="contest.password"
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="比赛赛制">
              <el-radio class="radio" v-model="contest.rule_type" label="1"
                >ACM</el-radio
              >
              <el-radio class="radio" v-model="contest.rule_type" label="2"
                >OI</el-radio
              >
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="实时排名">
              <el-switch
                v-model="contest.real_time_rank"
                active-color=""
                inactive-color=""
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-switch
                v-model="contest.visible"
                active-text=""
                inactive-text=""
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="允许的 IP 范围">
              <div
                v-for="(range, index) in contest.allowed_ip_ranges"
                :key="index"
              >
                <el-row :gutter="20" style="margin-bottom: 15px">
                  <el-col :span="8">
                    <el-input
                      v-model="range.value"
                      placeholder="CIDR网络"
                    ></el-input>
                  </el-col>
                  <el-col :span="10">
                    <el-button
                      plain
                      icon="el-icon-plus"
                      @click="addIPRange"
                    ></el-button>
                    <el-button
                      plain
                      icon="el-icon-delete-solid"
                      @click="removeIPRange(range)"
                    ></el-button>
                  </el-col>
                </el-row>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button type="primary"> 保存比赛 </el-button>
    </div>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'

export default {
  components: {
    Tinymce,
  },
  data() {
    return {
      contest: {
        visible: true,
        real_time_rank: true,
        rule_type: '1',
        allowed_ip_ranges: [
          {
            value: '',
          },
        ],
      },
    }
  },
  methods: {
    addIPRange() {
      this.contest.allowed_ip_ranges.push({ value: '' })
    },
    removeIPRange(range) {
      let index = this.contest.allowed_ip_ranges.indexOf(range)
      if (index !== -1) {
        this.contest.allowed_ip_ranges.splice(index, 1)
      }
    },
    goback() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.addCompetitionManagement {
  height: 100%;
  width: 100%;
}
.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;
  span {
    color: rgba(0, 0, 0, 0.45);
  }
}
.table {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}
</style>
